import { FeatureURI } from '@sbt-web/network/types';
import { formatMainData } from '@sbt-web/utils';

function getCategoryFeaturesValues(item) {
    const ad = item;
    const formattedFeatures = formatMainData(ad, {
        short: true,
        maxFeatures: 6,
    });
    const populatedFeatures = [];
    for (let index = 0; index < formattedFeatures.length; index++) {
        const feature = formattedFeatures[index];
        if (feature.label != '') {
            populatedFeatures.push(feature.label);
        }
    }
    return populatedFeatures;
}
function getItemAvailability(ad) {
    const item = ad;
    return (typeof item?.features?.[FeatureURI.TransactionStatus] === 'undefined' ||
        item?.features?.[FeatureURI.TransactionStatus] == null ||
        Object.keys(item?.features?.[FeatureURI.TransactionStatus]).length < 1);
}

export { getCategoryFeaturesValues, getItemAvailability };
//# sourceMappingURL=features.js.map
